export const userId = 5

export const users = [
  {
    id: 0,
    name: 'Janice Indradjaja',
    cravingCount: 6,
    smokingCount: 3,
  },
  {
    id: 1,
    name: 'Putra Sianipar',
    cravingCount: 2,
    smokingCount: 0,
  },
  {
    id: 2,
    name: 'Alan Tan',
    cravingCount: 5,
    smokingCount: 2,
  },
  {
    id: 3,
    name: 'Sarah Hermawati',
    cravingCount: 8,
    smokingCount: 7,
  },
  {
    id: 4,
    name: 'Mario Saputra',
    cravingCount: 5,
    smokingCount: 5,
  },
  {
    id: 5,
    name: 'Dani Wijaya',
    cravingCount: 6,
    smokingCount: 2,
  },
]

